import router from "./router";
import Cookies from "js-cookie";
import { decryptBy } from "./assets/js/encryption.js";
const whiteList = ["/login", "/paymentCallback"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  const hasToken = Cookies.get("token");
  let userInfo = localStorage.getItem("userInfo");
  let info = {};
  let children;
  if (localStorage.getItem("children")) {
    if (decryptBy(localStorage.getItem("children"))) {
      children = JSON.parse(decryptBy(localStorage.getItem("children")));
    }
  }
  if (userInfo) {
    info = JSON.parse(decryptBy(userInfo));
  }
  if (hasToken) {
    if (to.path === "/login") {
      if (info.userType) {
        next("/");
      } else {
        localStorage.clear();
        sessionStorage.clear();
        next();
      }
    } else {
      try {
        if (info.userType && ((info.userType !='PARENT') ||  (info.userType =='PARENT' && children && children.length>0))) {
          if (to.path == "/identity" || to.path == "/information") {
            next("/");
          } else {
            next();
          }
        } else {
          if (to.path == "/identity" || to.path == "/information") {
            next();
          } else {
            if(from.path == "/identity " || from.path == "/information") {
              next();
            } else {
              localStorage.clear();
              sessionStorage.clear();
              next("/login");
            }
            
          }
        }
      } catch (err) {
        Cookies.remove("token");
        localStorage.removeItem("childId");
        localStorage.removeItem("children");
        sessionStorage.removeItem("screenData");
        localStorage.clear();
        sessionStorage.clear();
        next("/login");
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      if(to.path == "/login") {
        localStorage.clear();
        sessionStorage.clear();
      }
      next();
    } else {
      localStorage.clear();
      sessionStorage.clear();
      next("/login");
    }
  }
});
